export const NoopActionType = "noop" as const;
export type NoopAction = ReturnType<typeof noopAction>;
export function noopAction() {
  return { type: NoopActionType };
}
